import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";

interface IHelpCenterTitleProps {
  children: string;
}

const HelpCenterTitle: React.FC<IHelpCenterTitleProps> = ({ children }) => {
  return (
    <SSHeadline
      props={{
        title: {
          order: 2,
          fz: 35,
          className: "pt-12 uppercase",
        },
        stack: {
          className: "items-start",
        },
      }}
    >
      <SSLoLGradientText className="font-secret-black">
        {children}
      </SSLoLGradientText>
    </SSHeadline>
  );
};

export default HelpCenterTitle;
